const diffs = [
  {
    n: "01",
    title: "Atendimento técnico e humanizado",
    desc: "Uma advocacia próxima, clara e acessível, sem excessos de linguagem técnica.",
  },
  {
    n: "02",
    title: "Atuação estratégica",
    desc: "Cada caso é conduzido com análise aprofundada, visão preventiva e foco em resultado.",
  },
  {
    n: "03",
    title: "Experiência consolidada",
    desc: "Mais de duas décadas de atuação jurídica consistente e especializada.",
  },
  {
    n: "04",
    title: "Segurança e discrição",
    desc: "Compromisso absoluto com ética, sigilo e proteção dos interesses dos clientes.",
  },
  {
    n: "05",
    title: "Atualização constante",
    desc: "Atuação conectada às transformações do Direito e às melhores práticas do mercado jurídico.",
  },
];

export default function Diferenciais() {
  return (
    <section id="diferenciais" className="section bg-white" data-testid="section-diferenciais">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-12">
            <p className="eyebrow text-brand-accent mb-6"><span className="thin-rule" />Diferenciais</p>
            <h2 className="font-serif text-brand-primary font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-3xl">
              Diferenciais do <em className="not-italic text-brand-accent">Escritório</em>.
            </h2>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-px bg-brand-primary/10">
          {diffs.map((d) => (
            <article
              key={d.n}
              data-testid={`diferencial-${d.n}`}
              className="bg-white p-8 lg:p-10 hover:bg-brand-soft transition-colors min-h-[260px] flex flex-col"
            >
              <span className="font-serif text-brand-accent text-3xl leading-none">{d.n}</span>
              <div className="mt-4 h-px w-10 bg-brand-primary/30" />
              <h3 className="font-serif text-brand-primary text-xl lg:text-2xl mt-6 leading-tight">
                {d.title}
              </h3>
              <p className="mt-3 text-[13px] leading-relaxed text-brand-text/75 flex-1">{d.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
